export const changePhotoModal = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '0 35px 48px',
		width: '100%',

		'@media (max-width: 1200px)': {
			padding: '0 0 48px',
		},
	},
	imagePickerWrap: {
		width: '100%',
		marginBottom: '72px',
	},
	imageLoader: {
		minHeight: '50vh',
	},
	title: {
		textAlign: 'center',
		color: 'var(--primary-700)',
		marginBottom: '16px',
	},

	btnWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		maxWidth: '370px',

		'@media (max-width: 640px)': {
			flexDirection: 'column',
			maxWidth: '100%',
			padding: '0 20px',
			gap: '12px',
		},
	},
	btn: {
		width: '100%',
		'&:first-of-type': {
			marginRight: '16px',
		},
	},
};
